module.exports = __webpack_public_path__ + "static/media/cloud-bookmark.192daf93.svg";